
        export const CometChatSettings = {
  "chatFeatures": {
    "coreMessagingExperience": {
      "typingIndicator": true,
      "threadConversationAndReplies": false,
      "photosSharing": true,
      "videoSharing": true,
      "audioSharing": true,
      "fileSharing": true,
      "editMessage": true,
      "deleteMessage": true,
      "messageDeliveryAndReadReceipts": true,
      "userAndFriendsPresence": true,
      "conversationAndAdvancedSearch": true,
      "moderation": true,
      "quotedReplies": true,
      "markAsUnread": true,
      "richTextFormatting": true
    },
    "deeperUserEngagement": {
      "mentions": true,
      "mentionAll": true,
      "reactions": true,
      "messageTranslation": true,
      "polls": true,
      "collaborativeWhiteboard": true,
      "collaborativeDocument": true,
      "voiceNotes": true,
      "emojis": true,
      "stickers": false,
      "userInfo": true,
      "groupInfo": true
    },
    "aiUserCopilot": {
      "conversationStarter": false,
      "conversationSummary": false,
      "smartReply": false
    },
    "userManagement": {
      "friendsOnly": true
    },
    "groupManagement": {
      "createGroup": false,
      "addMembersToGroups": false,
      "joinLeaveGroup": false,
      "deleteGroup": false,
      "viewGroupMembers": true
    },
    "moderatorControls": {
      "kickUsers": false,
      "banUsers": false,
      "promoteDemoteMembers": false,
      "reportMessage": false
    },
    "privateMessagingWithinGroups": {
      "sendPrivateMessageToGroupMembers": false
    },
    "inAppSounds": {
      "incomingMessageSound": true,
      "outgoingMessageSound": false
    }
  },
  "callFeatures": {
    "voiceAndVideoCalling": {
      "oneOnOneVoiceCalling": false,
      "oneOnOneVideoCalling": false,
      "groupVideoConference": false,
      "groupVoiceConference": false
    }
  },
  "layout": {
    "withSideBar": true,
    "tabs": [
      "chats",
      "users",
      "groups"
    ],
    "chatType": "user",
    "compactMessageComposer": true
  },
  "style": {
    "theme": "system",
    "color": {
      "brandColor": "#006f9c",
      "primaryTextLight": "#141414",
      "primaryTextDark": "#FFFFFF",
      "secondaryTextLight": "#727272",
      "secondaryTextDark": "#989898"
    },
    "typography": {
      "font": "roboto",
      "size": "default"
    }
  },
  "noCode": {
    "docked": false,
    "styles": {
      "buttonBackGround": "#141414",
      "buttonShape": "rounded",
      "openIcon": "https://cdn.jsdelivr.net/npm/@cometchat/chat-embed@latest/dist/icons/docked_open_icon.svg",
      "closeIcon": "https://cdn.jsdelivr.net/npm/@cometchat/chat-embed@latest/dist/icons/docked_close_icon.svg",
      "customJs": "",
      "customCss": "",
      "dockedAlignment": "right"
    }
  },
  "agent": {
    "chatHistory": true,
    "newChat": true,
    "agentIcon": "",
    "showAgentIcon": true
  }
};
      